@if (isEpcot) {
    <bs-digital-linear-result-combo
        [succeededSlip]="succeededSlip"
        [oddsDisplayFormat]="oddsDisplayFormat"
        [inColumn]="inColumn"
        [moduleName]="title"
        [betslipType]="systemType" />
} @else {
    <bs-digital-linear-result-system
        [succeededSlip]="succeededSlip"
        [oddsDisplayFormat]="oddsDisplayFormat"
        [inColumn]="inColumn"
        [moduleName]="title ?? ''" />
}
